import { render, staticRenderFns } from "./ValidityCheckerReport.vue?vue&type=template&id=4518a985&scoped=true"
import script from "./ValidityCheckerReport.vue?vue&type=script&lang=js"
export * from "./ValidityCheckerReport.vue?vue&type=script&lang=js"
import style0 from "./ValidityCheckerReport.vue?vue&type=style&index=0&id=4518a985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518a985",
  null
  
)

export default component.exports